import { makeStyles } from '@material-ui/core';
import { flexAlignCenter } from 'UI/utils/styles';

export const useStyles = makeStyles({
  employeesInfoRoute: {
    ...flexAlignCenter
  }
});
